import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authApi } from './redux/auth';
import { baseApi } from './redux/config';
import userReducer from './redux/features/userSlice';
import { settingsApi } from './redux/setting';
import { messageApi } from './redux/messageView';

const rootReducer = combineReducers({
  user: userReducer,
  [authApi.reducerPath]: authApi.reducer,
  // [forgotPasswordApi.reducerPath]: forgotPasswordApi.reducer,
  // [apiKeyApi.reducerPath]: apiKeyApi.reducer,
  // [umsApi.reducerPath]: umsApi.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [messageApi.reducerPath]: messageApi.reducer,
});

const persistConfig = {
  key: 'root',
  storage,
  version: 1,
  whitelist: ['user'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(
      authApi.middleware,
      baseApi.middleware,
      settingsApi.middleware,
      messageApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

